import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'

function openAppSignInModalAction (data) {
  return openModalAction(MODAL_ID.APP_SIGN_IN, data)
}

export default openAppSignInModalAction
